import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { categoryTagStyles } from "../../styles/categoryTagStyles";

interface CategoryTagValue {
  name: string;
  color: string;
}

interface CategoryTagProps {
  value: CategoryTagValue;
}

export const CategoryTag = ({ value }: CategoryTagProps) => {
  const theme = useTheme();
  const styles = categoryTagStyles(theme);

  if (!value?.name || !value.color) return null;

  return (
    <Box sx={styles.container}>
      <Box
        title={value.name}
        sx={{ ...styles.colorCircle, bgcolor: value.color }}
      >
        {value.name.charAt(0).toUpperCase()}
      </Box>
      <Box component="span">{value.name}</Box>
    </Box>
  );
};
